var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9277 11.1719H13.9277V5.17188C13.9277 4.61888 13.4797 4.17188 12.9277 4.17188C12.3757 4.17188 11.9277 4.61888 11.9277 5.17188V11.1719H5.92773C5.37573 11.1719 4.92773 11.6189 4.92773 12.1719C4.92773 12.7249 5.37573 13.1719 5.92773 13.1719H11.9277V19.1719C11.9277 19.7249 12.3757 20.1719 12.9277 20.1719C13.4797 20.1719 13.9277 19.7249 13.9277 19.1719V13.1719H19.9277C20.4797 13.1719 20.9277 12.7249 20.9277 12.1719C20.9277 11.6189 20.4797 11.1719 19.9277 11.1719Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6224_17262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9277 11.1719H13.9277V5.17188C13.9277 4.61888 13.4797 4.17188 12.9277 4.17188C12.3757 4.17188 11.9277 4.61888 11.9277 5.17188V11.1719H5.92773C5.37573 11.1719 4.92773 11.6189 4.92773 12.1719C4.92773 12.7249 5.37573 13.1719 5.92773 13.1719H11.9277V19.1719C11.9277 19.7249 12.3757 20.1719 12.9277 20.1719C13.4797 20.1719 13.9277 19.7249 13.9277 19.1719V13.1719H19.9277C20.4797 13.1719 20.9277 12.7249 20.9277 12.1719C20.9277 11.6189 20.4797 11.1719 19.9277 11.1719Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6224_17262)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d959fd842660ada48b65289c5d658c94.svg";
export { ForwardRef as ReactComponent };